import React from 'react'

import { ListItemGeneral } from '@interco/inter-toranja'
import { useActionHandler } from '@/hooks/useActionHandler'
import { useHomeCreditListItemTag } from '@/hooks/useHomeCreditListItemTag'

import { ListItem as ListItemCard } from '../../../ListItem'
import * as S from './styles'

interface ListItemSDUIProps {
  items: ListItemData[]
  style?: { marginTop?: string; marginBottom?: string }
  componentAnalytics?: Analytics
}

export const ListItemSDUI: React.FC<ListItemSDUIProps> = ({ items, style, componentAnalytics }) => {
  const { dispatchAction } = useActionHandler()
  const fireListItemTag = useHomeCreditListItemTag()
  const isContainedVariant = items?.some((item) => item.variant === 'contained')

  if (isContainedVariant) {
    return (
      <S.ContainerListItemContained style={style}>
        {items?.map((item) => (
          <S.ContainerListItemContainedItem key={item.id} style={item.style}>
            <ListItemCard
              key={item.id}
              label={item.title}
              paragraph={item.description}
              tags={
                item.tag
                  ? [{ label: item.tag, color: (item.colorTag as 'orange') ?? 'orange' }]
                  : undefined
              }
              variant="contained"
              showDivider={item.showDivider === 'enabled'}
              onTag={(tag) => fireListItemTag(tag, item.title)}
              onClick={() => dispatchAction(item.action, item.analytics ?? componentAnalytics)}
            />
          </S.ContainerListItemContainedItem>
        ))}
      </S.ContainerListItemContained>
    )
  }

  return (
    <S.ContainerListItemDefault style={style}>
      {items.map((item) => (
        <ListItemGeneral
          key={item.id}
          label={item.title}
          showDivider={item.showDivider === 'enabled'}
          variant="inset"
          leadingProps={{
            iconProps: {
              asset: (item.icon ?? '') as never,
              color: 'Icon/Neutral/Primary',
              contentDescription: 'Icon',
              size: 'medium',
            },
            type: 'icon',
          }}
          trailingProps={{
            tagChevronProps: {
              showTag: false,
              tagColor: 'brand',
              tagLabel: 'Label',
            },
            type: 'tagChevron',
          }}
          onTag={(tag) => fireListItemTag(tag, item.title)}
          onClick={() => dispatchAction(item.action, item.analytics ?? componentAnalytics)}
        />
      ))}
    </S.ContainerListItemDefault>
  )
}
